import { useRef, useState } from 'react';
import {
  Check2,
  Copy,
  HandThumbsDown,
  HandThumbsDownFill,
  HandThumbsUp,
  HandThumbsUpFill,
} from 'react-bootstrap-icons';
import { useChatContext } from '../../context/ChatProvider';
import { ChatMessageFeedback } from '../../lib/types';
import './feedbackActions.scss';
import { useToast } from '../../../../../context';

interface FeedbackActionsProps {
  messageId: string;
  messageText: string;
}

const FeedbackActions = ({ messageId, messageText }: FeedbackActionsProps) => {
  const [isCopied, setIsCopied] = useState(false);
  const { setToast } = useToast();
  const copyTimerRef = useRef<number | null>(null);
  const { messageFeedback, setMessageFeedback } = useChatContext();
  const selectedFeedback = messageFeedback[messageId];
  const hasThumbsUp = Boolean(
    selectedFeedback?.[ChatMessageFeedback.THUMBS_UP],
  );
  const hasThumbsDown = Boolean(
    selectedFeedback?.[ChatMessageFeedback.THUMBS_DOWN],
  );

  const onCopy = async () => {
    try {
      await navigator.clipboard.writeText(messageText);
      setIsCopied(true);

      if (copyTimerRef.current) {
        window.clearTimeout(copyTimerRef.current);
      }

      setToast('Text copied');

      copyTimerRef.current = window.setTimeout(() => {
        setIsCopied(false);
        copyTimerRef.current = null;
      }, 4000);
    } catch (e) {
      console.log('Failed to copy text: ', e);
      setIsCopied(false);
      setToast('Failed to copy text');
      copyTimerRef.current = null;
    }
  };

  return (
    <div className="chat-feedback-actions">
      <button
        type="button"
        className="chat-feedback-actions__button"
        aria-label="Copy assistant response"
        onClick={() => {
          void onCopy();
        }}
      >
        {isCopied ? <Check2 size={18} /> : <Copy size={18} />}
      </button>
      <button
        type="button"
        className="chat-feedback-actions__button"
        aria-label="Mark assistant response as helpful"
        onClick={() =>
          setMessageFeedback(messageId, ChatMessageFeedback.THUMBS_UP)
        }
      >
        {hasThumbsUp ? (
          <HandThumbsUpFill size={18} />
        ) : (
          <HandThumbsUp size={18} />
        )}
      </button>
      <button
        type="button"
        className="chat-feedback-actions__button"
        aria-label="Mark assistant response as unhelpful"
        onClick={() =>
          setMessageFeedback(messageId, ChatMessageFeedback.THUMBS_DOWN)
        }
      >
        {hasThumbsDown ? (
          <HandThumbsDownFill size={18} />
        ) : (
          <HandThumbsDown size={18} />
        )}
      </button>
    </div>
  );
};

export default FeedbackActions;
